const ERROR_CODE = {
  VALIDATION: '010001',
  INVALID_REFRESH_TOKEN: '010006',
  GROUP_NOT_FOUND: '060000',
  DRAFT_STALE_VERSION: '060001',
  ITEMS_INVALID: '060002',
  REORDER_MISMATCH: '060003',
  LIFECYCLE_UNSUPPORTED: '060004',
  SCHEDULE_WINDOW_INVALID: '060005',
  ACTIVE_GROUP_DELETE: '060007',
  DRAFT_NOT_PUBLISHABLE: '060009',
  METABASE_UNREACHABLE: '060010',
  SEGMENT_NOT_FOUND: '060012',
  SEGMENT_KEY_EXISTS: '060013',
} as const;

export default ERROR_CODE;
